// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2awiJ","disabled":"FileBtn_disabled__c7my2","warn":"FileBtn_warn__3ijwV","fade":"FileBtn_fade__1B14M"};